
export class EnvelopeInfo {
    id: number; // Also order
    address: string;
    frame: string;

    constructor(id: number, address: string, frame: string) {
        this.id = id;
        this.address = address;
        this.frame = frame;
    }
}

export class Envelope extends Phaser.GameObjects.Image {
    id: number;
    address: string;
    delivered: boolean;

    constructor(scene: Phaser.Scene, x: number, y: number, info: EnvelopeInfo) {
        super(scene, x, y, "assets", info.frame);

        this.id = info.id;
        this.address = info.address;
        this.delivered = false;
        // this.setScale(0.9);

        this.setInteractive();
        scene.input.setDraggable(this);
        scene.add.existing(this);
    }

    public static Envelopes: EnvelopeInfo[] = [
        new EnvelopeInfo(1, "101 Lightyear Lane.", "invitation1"),
        new EnvelopeInfo(5, "101 Asteroid Alley", "invitation6"),
        new EnvelopeInfo(3, "103 Lightyear Lane.", "invitation3"),
        new EnvelopeInfo(6, "201 Asteroid Alley", "invitation5"),
        new EnvelopeInfo(2, "102 Lightyear Lane.", "invitation2"),
        new EnvelopeInfo(7, "308 Asteroid Alley", "invitation7"),
        new EnvelopeInfo(4, "600 Big Bang Blvd.", "invitation4"),
    ];
}



// WEBPACK FOOTER //
// ./src/games/MailDeliveryGame/objects/Envelope.ts